import React from "react";
import Footer from "./Footer";
import HeaderInner from "./HeaderInner";

export default function PerformaInvoice() {
  return (
    <div>
      <HeaderInner pageTitle="Performa Invoice" />
      <div className="AppPage container--narrow mt"></div>
      <Footer />
    </div>
  );
}
